export default __webpack_public_path__ + "static/media/alen-tomy.cca375fe.jpg";